import { useState, useEffect } from 'react';
import { Table, TableBody, Paper, Button, Grid, TableRow, TableCell, Dialog, DialogTitle, TableHead, DialogContent, Tooltip, TextField } from '@material-ui/core';
import { globalGetService, globalPutService } from '../../../utils/globalApiServices';
import { useSnackbar } from 'notistack';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import { withRouter, Link } from 'react-router-dom/cjs/react-router-dom';
import { ConfgureTab } from '../components';
import { EmptyCollection, PageLoader, DeletePopUp } from '../../../shared_elements';
import FilterComponent from '../../../shared_elements/components/filter_component';
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import Pagination from '../../../shared_elements/components/Pagination';
import { trackActivity } from '../../../utils/mixpanel';
import { checkApiStatus, getLocalStorageInfo } from '../../../utils';
import { utilApprovaFilterOpt } from '.';
import { isMobile } from 'react-device-detect';
import { dayMonthDateFormat } from '../../../constants';
import moment from 'moment';

const renderText = (val) => {
    if (val === null || val === undefined) return '--';
    if (typeof val === 'object') return '--';
    return String(val);
};

const UtilizationApprovalHeader = () => {
    const canSeeActions = !!getLocalStorageInfo()?.user?.security_groups?.find((item) => item?.id === 29);
    return (
        <TableHead>
            <TableRow>
                <TableCell>User</TableCell>
                <TableCell>ESN</TableCell>
                <TableCell>Utilization Period</TableCell>
                <TableCell>Monthly FH</TableCell>
                <TableCell>Monthly FC</TableCell>
                <TableCell>Status</TableCell>
                {canSeeActions ? <TableCell>Actions</TableCell> : null}
                <TableCell>Remarks</TableCell>
            </TableRow>
        </TableHead>
    );
};

const UtilizationApprovalList = ({ item, toggleAprRejFn, utilFlowApproval }) => {
    const canSeeActions = !!getLocalStorageInfo()?.user?.security_groups?.some((g) => g?.id === 29);
    const statusLabel = item?.util_approval_status?.label;
    return (
        <TableRow>
            <TableCell>{renderText(item?.created_by?.name)}</TableCell>
            <TableCell>
                {item?.esn && typeof item.esn !== 'object' ? (
                    <Link
                        style={{ cursor: 'pointer' }}
                        to={`/${item?.asset_id}/${item?.asset_type_id}/utilization/list`}
                        target="_self"
                    >
                        {renderText(item.esn)}
                    </Link>
                ) : (
                    '--'
                )}
            </TableCell>
            <TableCell> {item?.utilization_period && typeof item.utilization_period !== 'object' ? (moment(item.utilization_period).format(dayMonthDateFormat)) : ('--')} </TableCell>
            <TableCell>{renderText(item?.monthly_FH)}</TableCell>
            <TableCell>{renderText(item?.monthly_FC)}</TableCell>
            <TableCell>
                {utilFlowApproval ? (item?.util_approval_status?.id === 4 ? ('--') : (<span className={renderText(statusLabel)}> {renderText(statusLabel)} </span>)) : ('--')}
            </TableCell>
            {canSeeActions && (
                <TableCell>
                    {item?.util_approval_status?.id === 3 ? (
                        <>
                            <Tooltip title="Approve" placement="top">
                                <CheckIcon
                                    style={{ cursor: 'pointer' }}
                                    color="primary"
                                    onClick={() => toggleAprRejFn('approve')}
                                />
                            </Tooltip>
                            <Tooltip title="Reject" placement="top">
                                <CloseIcon
                                    style={{ cursor: 'pointer' }}
                                    color="secondary"
                                    onClick={() => toggleAprRejFn('reject')}
                                />
                            </Tooltip>
                        </>
                    ) : (
                        '--'
                    )}
                </TableCell>
            )}
            <TableCell>{renderText(item?.reject_remarks)}</TableCell>
        </TableRow>
    );
};

const UtilizationRejcetModal = ({ data, onFieldChange, toggleModalClose, onRestErrorKey, onRejectFn, error }) => {
    return (
        <Dialog
            open={true}
            aria-labelledby="scroll-dialog-title"
            maxWidth="sm"
            className="delete-record-modal"
        >
            <DialogTitle id="scroll-dialog-title">
                Reject Utilization Approval
            </DialogTitle>
            <DialogContent dividers={true}>
                <div style={isMobile ? { width: 'auto' } : { minWidth: '400px' }}>
                    <div>
                        <TextField
                            required
                            variant="outlined"
                            margin="normal"
                            label="Remarks"
                            id="reject_remarks"
                            fullWidth
                            error={!!error?.reject_remarks}
                            helperText={error?.reject_remarks || ''}
                            inputProps={{ maxLength: 50 }}
                            value={data?.reject_remarks || ''}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                                onFieldChange('reject_remarks', e.target.value);
                                onRestErrorKey('reject_remarks');
                            }}
                        />
                    </div>
                    <div className="actions-cta">
                        <Button variant="outlined" onClick={toggleModalClose} color="primary"> Cancel </Button>
                        <Button variant="contained" onClick={() => onRejectFn(data?.reject_remarks)} color="secondary" > Reject </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

function UtilizationApproval({ match }) {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [error, setError] = useState({});
    const [rejectRemarks, setRejectRemarks] = useState({ reject_remarks: '' });
    const [utilizationApproval, setUtilizationApproval] = useState({ results: [], pagination: {} });
    const [approveReject, setApproveReject] = useState({ modal: false, data: null, type: null });
    const utilFlowApproval = JSON.parse(localStorage.getItem('utiFlow_approval'));
    const [usersList, setUsersList] = useState([]);

    useEffect(() => {
        getUsersListFn()
        getUtilizationApproval({ ...filter, per_page: 20 }, 'skeletonLoader');
        trackActivity('Utilization Approval - Airworthiness Management', {
            event_type: 'Page Visited',
            page_title: 'Utilization Approval Tab from Configure Section'
        });

    }, []);

    const onFieldChange = (key, value) => {
        setRejectRemarks((prev) => ({ ...prev, [key]: value }));
    };

    const onRestErrorKey = (keyParam) => {
        if (!keyParam) {
            setError({});
        } else {
            setError((prev) => ({ ...prev, [keyParam]: '' }));
        }
    };

    const normalizeResults = (results = []) => {
        const safeResults = Array.isArray(results) ? results : [];

        return safeResults.map((row) => {
            if (!row || typeof row !== 'object') return {};

            const safeStatus = row?.util_approval_status || {};
            return {
                ...row,
                monthly_FH:
                    typeof row?.monthly_FH === 'object' ? null : row?.monthly_FH,
                monthly_FC:
                    typeof row?.monthly_FC === 'object' ? null : row?.monthly_FC,
                reject_remarks:
                    typeof row?.reject_remarks === 'object' ? null : row?.reject_remarks,
                util_approval_status: {
                    ...safeStatus,
                    label:
                        typeof safeStatus?.label === 'object' ? null : safeStatus?.label
                }
            };
        });
    };

    const getUtilizationApproval = (query = {}, loaderType) => {
        if (loaderType === 'skeletonLoader') {
            setSkeletonLoader(true);
        } else {
            setLoading(true);
        }
        globalGetService('camo/util_approval/', query).then((response) => {
            if (checkApiStatus(response)) {
                const rawResults = response?.data?.results;
                const normalizedResults = normalizeResults(rawResults);
                setUtilizationApproval({ results: normalizedResults, pagination: response?.data?.pagination || {} });
                const cleanedQuery = { ...query };
                delete cleanedQuery.page;
                delete cleanedQuery.per_page;
                delete cleanedQuery.sort;
                delete cleanedQuery.sort_by;
                setFilter(cleanedQuery);
            } else {
                enqueueSnackbar(response?.data?.message || 'Something went wrong!', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            }

            if (loaderType === 'skeletonLoader') {
                setSkeletonLoader(false);
            } else {
                setLoading(false);
            }
        });
    };

    const onApproveRejectFn = (value, remarks) => {
        setLoading(true);
        const trimmedRemarks = (rejectRemarks?.reject_remarks || '').trim();
        const validationInputs = { reject_remarks: value?.id === 1 || trimmedRemarks ? '' : 'Please enter remarks' };
        const isValid = Object.values(validationInputs).every((v) => v === '');

        if (isValid) {
            globalPutService(`camo/util_approval/${approveReject?.data?.id}/`, { ...approveReject?.data, util_approval_status: value, reject_remarks: value?.id === 2 ? (remarks || trimmedRemarks) : null }).then((response) => {
                if (checkApiStatus(response)) {
                    setLoading(false);
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setApproveReject({ modal: false, data: null, type: null });
                    setRejectRemarks({ reject_remarks: '' });
                    onRestErrorKey();
                    getUtilizationApproval({ ...filter, per_page: utilizationApproval?.pagination?.per_page || 20 });
                    trackActivity('Utilization Approval/Rejected - Airworthiness Management', { event_type: 'Utilization Approval/Reject', util_approval_status: value, success_msg: response?.data?.message });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
            });
        } else {
            setLoading(false);
            setError(validationInputs);
        }
    };

    const getUsersListFn = () => {
        globalGetService('camo/camo_user_list/', { application: 19 })
            .then(response => {
                if (checkApiStatus(response)) {
                    let responseData = response.data?.data?.filter(item => {
                        return (
                            { ...item, name: `${item?.name || ''}` }
                        )
                    })
                    setUsersList(responseData)
                }
            })
    }

    const filterObj = { ...filter, };

    let filterOptions = Object.assign({}, utilApprovaFilterOpt);
    filterOptions = {
        ...filterOptions,
        user: {
            ...filterOptions.user,
            options: usersList || []
        },
    }
    if (!utilFlowApproval) {
        return <ConfgureTab tabIndex="disclaimer" via={true} />;
    }
   
    return (
        <>
            <ConfgureTab tabIndex="utilization-approval" />
            <section className="camo-fleet-module utilization-approval">
                {skeletonLoader ? (
                    <STableLoader count={10} />
                ) : (
                    <>
                        <Paper square elevation={2} variant="outlined" style={{ padding: '5px 10px' }} >
                            <Grid container spacing={1} alignItems="center">
                                <Grid item md={9}>
                                    <div style={{ marginTop: '2px' }}>
                                        <FilterComponent
                                            filter={filterObj}
                                            filterMenu={filterOptions}
                                            getResponseBack={(applyFilter) => getUtilizationApproval({ ...applyFilter, page: 1, per_page: utilizationApproval?.pagination?.per_page || 20 }, 'pageLoader')}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </Paper>

                        <Paper variant="outlined" square style={{ marginBottom: 5 }}>
                            <div style={{ height: !utilizationApproval.results.length ? 'auto' : `${window.innerHeight - 250}px`, overflow: 'auto' }} >
                                <Table className="mui-table-format" stickyHeader>
                                    <UtilizationApprovalHeader />
                                    <TableBody>
                                        {utilizationApproval.results.map((item, index) => {
                                            if (!item || typeof item !== 'object') return null;

                                            return (
                                                <UtilizationApprovalList
                                                    key={item?.id ?? index}
                                                    item={item}
                                                    utilFlowApproval={utilFlowApproval}
                                                    toggleAprRejFn={(type) => setApproveReject({ modal: true, data: item, type })}
                                                />
                                            );
                                        })}
                                    </TableBody>
                                </Table>

                                {!utilizationApproval.results.length && (
                                    <div style={{ textAlign: 'center' }}>
                                        <EmptyCollection title="No records found" />
                                    </div>
                                )}
                            </div>

                            {Object.keys(utilizationApproval.pagination).length > 0 && (
                                <Pagination
                                    pagination={utilizationApproval.pagination}
                                    onChangePage={(event, newPage) => getUtilizationApproval({ ...filter, page: newPage + 1, per_page: utilizationApproval.pagination.per_page || 20 }, 'pageLoader')}
                                    onChangeRowsPerPage={(event) => getUtilizationApproval({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                                />
                            )}
                        </Paper>
                    </>
                )}

                {approveReject.modal && approveReject.type === 'approve' && (
                    <DeletePopUp
                        modal={approveReject.modal}
                        title="Approve Utilization Approval"
                        content="Are you sure, you want to Approve"
                        toggleModalFn={() => setApproveReject({ modal: false, data: null, type: null })}
                        deleteRecordFn={() => onApproveRejectFn({ id: 1, label: 'Approved' })}
                        confirmText="Approve"
                    />
                )}

                {approveReject.modal && approveReject.type === 'reject' && (
                    <UtilizationRejcetModal
                        data={rejectRemarks}
                        error={error}
                        onRestErrorKey={onRestErrorKey}
                        onFieldChange={onFieldChange}
                        toggleModalClose={() => { setApproveReject({ modal: false, data: null, type: null }); setRejectRemarks({ reject_remarks: '' }); onRestErrorKey(); }}
                        onRejectFn={(remarks) => onApproveRejectFn({ id: 2, label: 'Reject' }, remarks)}
                    />
                )}
                {isLoading && <PageLoader />}
            </section>
        </>
    );
}

export default withRouter(UtilizationApproval);
